<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" id="_idContainer009" role="doc-toc">
<p class="TOCtitle">Contents</p>
<p class="TOCitem"><a href="#/Chapter_One#_idTextAnchor000">CHAPTER ONE</a></p>
<p class="TOCitem"><a href="#/Chapter_Two#_idTextAnchor001">CHAPTER TWO</a></p>
<p class="TOCitem"><span href="#/Chapter_Three#_idTextAnchor002" title="Link target outside of Sample">CHAPTER THREE</span></p>
<p class="TOCitem"><span href="#/Chapter_Four#_idTextAnchor003" title="Link target outside of Sample">CHAPTER FOUR</span></p>
<p class="TOCitem"><span href="#/Chapter_Five#_idTextAnchor004" title="Link target outside of Sample">CHAPTER FIVE</span></p>
<p class="TOCitem"><span href="#/Chapter_Six#_idTextAnchor005" title="Link target outside of Sample">CHAPTER SIX</span></p>
<p class="TOCitem"><span href="#/Chapter_Seven#_idTextAnchor006" title="Link target outside of Sample">CHAPTER SEVEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Eight#_idTextAnchor007" title="Link target outside of Sample">CHAPTER EIGHT</span></p>
<p class="TOCitem"><span href="#/Chapter_Nine#_idTextAnchor008" title="Link target outside of Sample">CHAPTER NINE</span></p>
<p class="TOCitem"><span href="#/Chapter_Ten#_idTextAnchor009" title="Link target outside of Sample">CHAPTER TEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Eleven#_idTextAnchor010" title="Link target outside of Sample">CHAPTER ELEVEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Twelve#_idTextAnchor011" title="Link target outside of Sample">CHAPTER TWELVE</span></p>
<p class="TOCitem"><span href="#/Chapter_Thirteen#_idTextAnchor012" title="Link target outside of Sample">CHAPTER THIRTEEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Fourteen#_idTextAnchor013" title="Link target outside of Sample">CHAPTER FOURTEEN</span></p>
<p class="TOCitem"><span href="#/A_Sneak_Peek_At_Syndi_Powell_Next_Novel#_idTextAnchor014" title="Link target outside of Sample">A SNEAK PEEK AT SYNDI POWELL'S NEXT NOVEL</span></p>
<p class="TOCitem"><span href="#/Excerpt_from_After_the_Rodeo_by_Claire_McEwen#_idTextAnchor015" title="Link target outside of Sample">EXCERPT FROM <i>AFTER THE RODEO</i> BY CLAIRE McEWEN</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?320d6b98